import { Mic, MicOff, Video as VideoIcon, MonitorUp, MessageSquare, PhoneOff } from "lucide-react";

const ADVISOR = "https://images.unsplash.com/photo-1758874573822-d6c79fd1b216?crop=entropy&cs=srgb&fm=jpg&q=85&w=640";
const CLIENT = "https://images.unsplash.com/photo-1588026193712-31163b26c043?crop=entropy&cs=srgb&fm=jpg&q=85&w=640";

export const VideoCallPreview = () => {
  return (
    <div className="relative mx-auto max-w-3xl" data-testid="video-call-preview">
      <style>{`
        @keyframes dfSpeakA { 0%,100%{opacity:0} 20%,45%{opacity:1} 55%{opacity:0} }
        @keyframes dfSpeakB { 0%,50%{opacity:0} 65%,90%{opacity:1} 100%{opacity:0} }
        @keyframes dfBlink { 0%,100%{opacity:1} 50%{opacity:.35} }
        @keyframes dfFloat { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }
      `}</style>
      <div className="rounded-[24px] border border-white/10 bg-[#0f0f12] shadow-2xl overflow-hidden" style={{ animation: "dfFloat 6s ease-in-out infinite" }}>
        {/* top bar */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-white/10 bg-black/40">
          <div className="flex items-center gap-2">
            <span className="font-display font-black text-white text-sm">Defer<span className="text-ally-pink">Ally</span> <span className="text-white/40 font-sans font-medium">Meet</span></span>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center gap-1.5 text-[11px] font-bold text-white/80">
              <span className="w-2 h-2 rounded-full bg-red-500" style={{ animation: "dfBlink 1.6s ease-in-out infinite" }} /> LIVE
            </span>
            <span className="text-[11px] font-mono text-white/50">04:12</span>
          </div>
        </div>
        {/* tiles */}
        <div className="relative grid grid-cols-2 gap-2 p-2 bg-black">
          {[
            { img: CLIENT, name: "Margaret Chen", tag: "Client", anim: "dfSpeakA", muted: false },
            { img: ADVISOR, name: "You", tag: "Qualified Intermediary", anim: "dfSpeakB", muted: false },
          ].map((t) => (
            <div key={t.name} className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-white/5">
              <img src={t.img} alt={t.name} className="w-full h-full object-cover" loading="lazy" />
              <div className="absolute inset-0 rounded-2xl ring-[3px] ring-ally-pink pointer-events-none" style={{ animation: `${t.anim} 8s ease-in-out infinite` }} />
              <div className="absolute bottom-2 left-2 flex items-center gap-1.5 bg-black/60 backdrop-blur rounded-full pl-2 pr-2.5 py-1">
                {t.muted ? <MicOff size={12} className="text-red-400" /> : <Mic size={12} className="text-white" />}
                <span className="text-white text-[11px] font-bold">{t.name}</span>
              </div>
              <div className="absolute top-2 left-2 text-[9px] uppercase tracking-wider font-bold text-white/70 bg-white/10 rounded-full px-2 py-0.5">{t.tag}</div>
            </div>
          ))}
        </div>
        {/* controls */}
        <div className="flex items-center justify-center gap-2.5 py-3.5 border-t border-white/10 bg-black/40">
          {[Mic, VideoIcon, MonitorUp, MessageSquare].map((Icon, i) => (
            <div key={i} className="h-9 w-9 rounded-full bg-white/10 flex items-center justify-center text-white/80 hover:bg-white/15 transition-colors">
              <Icon size={16} />
            </div>
          ))}
          <div className="h-9 px-4 rounded-full bg-red-500 flex items-center gap-1.5 text-white text-xs font-bold ml-1">
            <PhoneOff size={15} /> Leave
          </div>
        </div>
      </div>
      <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 bg-ally-pink text-white text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full shadow-lg whitespace-nowrap">
        Fully in your brand · no downloads
      </div>
    </div>
  );
};
